import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api/client";
import { count as queueCount, flush as flushQueue } from "../lib/offlineQueue";

const OfflineCtx = createContext(null);

export function OfflineProvider({ children }) {
    const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
    const [queued, setQueued] = useState(0);

    const refreshCount = useCallback(async () => {
        try {
            const c = await queueCount();
            setQueued(c);
        } catch (_) {}
    }, []);

    const tryFlush = useCallback(async () => {
        try {
            await flushQueue(api);
        } catch (_) {}
        refreshCount();
    }, [refreshCount]);

    useEffect(() => {
        refreshCount();
        const on = () => { setOnline(true); tryFlush(); };
        const off = () => setOnline(false);
        window.addEventListener("online", on);
        window.addEventListener("offline", off);
        // periodic reconcile
        const t = setInterval(refreshCount, 4000);
        return () => {
            window.removeEventListener("online", on);
            window.removeEventListener("offline", off);
            clearInterval(t);
        };
    }, [refreshCount, tryFlush]);

    return (
        <OfflineCtx.Provider value={{ online, queued, refreshCount, tryFlush }}>
            {children}
        </OfflineCtx.Provider>
    );
}

export function useOffline() {
    const v = useContext(OfflineCtx);
    if (!v) throw new Error("useOffline outside provider");
    return v;
}
